import { render, staticRenderFns } from "./AdviseDashboard.vue?vue&type=template&id=61c2e634"
import script from "./AdviseDashboard.vue?vue&type=script&lang=js"
export * from "./AdviseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports